import styled from '@emotion/styled';
import H from '@zola/zola-ui/src/typography/Headings';
import P from '@zola/zola-ui/src/typography/Paragraphs';
import COLORS3 from '@zola/zola-ui/src/styles/emotion/colors3';
import FONT from '@zola/zola-ui/src/styles/emotion/fonts';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';

export const CarouselContainer = styled.div`
  border-bottom: 1px solid ${COLORS3.BLACK_030};
  padding: ${SPACING.LG};

  ${MEDIA_QUERY_V2.MOBILE} {
    padding: ${SPACING.S32} ${SPACING.S24};
  }
`;

export const CarouselTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CarouselTitle = styled(H.Title3)`
  ${MEDIA_QUERY_V2.MOBILE} {
    ${FONT.textSizeUltraCompact(FONT.SIZE.REGULAR)};
  }
`;

const tileWidth = `
  width: 150px;
  ${MEDIA_QUERY_V2.TABLET} {
    width: 182px;
  }
  ${MEDIA_QUERY_V2.DESKTOP} {
    width: 270px;
  }
  ${MEDIA_QUERY_V2.DESKTOP_XL} {
    width: 350px;
  }
`;

const imageHeight = `
  height: 113px;
  ${MEDIA_QUERY_V2.TABLET} {
    height: 137px;
  }
  ${MEDIA_QUERY_V2.DESKTOP} {
    height: 203px;
  }
  ${MEDIA_QUERY_V2.DESKTOP_XL} {
    height: 263px;
  }
`;

export const TileImageContainer = styled.div`
  display: flex;
  overflow: hidden;
  border-radius: 16px;
  ${tileWidth};
  ${imageHeight};
`;

export const TileImage = styled.img`
  transition: all 0.2s ease-in-out;
  ${tileWidth};
  ${imageHeight};
  > img {
    object-fit: cover;
    ${tileWidth};
    ${imageHeight};
  }
`;

export const TileTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${SPACING.S16};
  ${MEDIA_QUERY_V2.DESKTOP} {
    margin-top: ${SPACING.S24};
  }
`;

const smallerFontSize = `
  ${MEDIA_QUERY_V2.EXCLUDE_DESKTOP} {
    font-size: ${FONT.SIZE.SMALLER};
  }
`;

export const TileTag = styled(P.BodyBase)`
  order: 1;
  color: ${COLORS3.BLACK_050};
  ${smallerFontSize};
`;

export const TileHeading = styled(H.TitleMedium4)`
  order: 2;
  white-space: pre-wrap;
  margin: ${SPACING.XXS} 0 ${SPACING.XS};
  ${MEDIA_QUERY_V2.DESKTOP} {
    margin: ${SPACING.XXS} 0 ${SPACING.S16};
  }
  ${smallerFontSize};
`;

export const TileParagraph = styled(P.BodyBase)`
  order: 3;
  color: ${COLORS3.BLACK_075};
  display: -webkit-box;
  overflow: hidden;
  white-space: pre-wrap;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  ${MEDIA_QUERY_V2.TABLET} {
    -webkit-line-clamp: 4;
  }
  ${MEDIA_QUERY_V2.DESKTOP_LG} {
    -webkit-line-clamp: 3;
  }
  ${MEDIA_QUERY_V2.DESKTOP_XL} {
    -webkit-line-clamp: 2;
  }
  ${smallerFontSize};
`;

export const TileLink = styled.a`
  ${tileWidth};
  text-decoration: none;

  @media (hover: hover) {
    :hover {
      text-decoration: none;
      ${TileImage} {
        transform: scale(1.1);
      }
      ${TileHeading} {
        text-decoration: underline;
      }
    }
  }
`;
